<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'AdendumContractPage',

};
</script>

<style>

</style>
